<template>
  <div>
    <hr>
    <div class="row needs-padding-bottom">
      <i v-if="reviewerId === getCognitoId" v-on:click="remove" class="fa fa-window-close" aria-hidden="true"></i>
      <p v-if="(reviewerId === getCognitoId) && !editing" v-on:click="edit" class="edit-button">Edit</p>
      <p v-if="(reviewerId === getCognitoId) && editing" v-on:click="save" class="save-button">Save</p>
      <p v-if="(reviewerId === getCognitoId) && editing" v-on:click="cancel" class="cancel-button">Cancel</p>
      <div v-if="profileImageUrl" class="col-md-2">
        <img class="round-image" v-bind:src="profileImageUrl">
      </div>
      <div class="col-md-10">
        <router-link v-if="path" v-bind:to="path">
          <h4>{{ reviewer }}</h4>
        </router-link>
        <div v-else>
          <h4>{{ reviewer }}</h4>
        </div>
        <div v-if="!editing">
          <stars :rating="rating"></stars>
          <p>{{ review }}</p>
        </div>
        <div v-else>
        <i v-on:click="setRating = yourRating"
           @mouseover="yourRating = 1"
           @mouseout="yourRating = setRating"
           class="fa-star"
           v-bind:class="{ fas: yourRating >= 1 , far: yourRating < 1 }"></i>
        <i v-on:click="setRating = yourRating"
           @mouseover="yourRating = 2"
           @mouseout="yourRating = setRating"
           class="fa-star"
           v-bind:class="{ fas: yourRating >= 2 , far: yourRating < 2 }"></i>
        <i v-on:click="setRating = yourRating"
           @mouseover="yourRating = 3"
           @mouseout="yourRating = setRating"
           class="fa-star"
           v-bind:class="{ fas: yourRating >= 3 , far: yourRating < 3 }"></i>
        <i v-on:click="setRating = yourRating"
           @mouseover="yourRating = 4"
           @mouseout="yourRating = setRating"
           class="fa-star"
           v-bind:class="{ fas: yourRating >= 4 , far: yourRating < 4 }"></i>
        <i v-on:click="setRating = yourRating"
           @mouseover="yourRating = 5"
           @mouseout="yourRating = setRating"
           class="fa-star"
           v-bind:class="{ fas: yourRating === 5 , far: yourRating !== 5 }"></i>
          <textarea v-model="editedReviewText" class="form-control no-padding padding-bottom" rows="5" id="comment"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stars from '../Stars.vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      editing: false,
      editedReviewText: null,
      yourRating: null,
      setRating: null
    }
  },
  components: {
    stars
  },
  props: {
    rating: Number,
    profilePic: String,
    review: String,
    datePosted: String,
    reviewer: String,
    reviewerId: String,
    reviewId: String,
    path: String
  },
  computed: {
    ...mapGetters([
      'getSecretAccessKey',
      'getCognitoId'
    ]),
    profileImageUrl () {
      if (!this.profilePic) return null
      var pathArray = this.profilePic.split('/')
      var lastPath = pathArray.slice(-1)[0]
      if (!this.profilePic) return '/static/defaultprofile.png'
      if (lastPath !== 'null') return this.profilePic
      return '/static/defaultprofile.png'
    }
  },
  methods: {
    async remove () {
      var client = this.$store.getters.getReviewApigClientFactory
      var params = {
        review_id: this.reviewId
      }
      var pathTemplate = '/reviews/{review_id}'
      var method = 'DELETE'
      var additionalParams = {}
      var body = {}
      try {
        this.$emit('loading')
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.$emit('reload')
      } catch (error) {
        this.$emit('loading')
        console.log(error)
      }
    },
    edit () {
      this.editing = true
      this.editedReviewText = this.review
      this.setRating = this.rating
      this.yourRating = this.rating
    },
    async save () {
      var client = this.$store.getters.getReviewApigClientFactory
      var params = {
        review_id: this.reviewId
      }
      var pathTemplate = '/reviews/{review_id}'
      var method = 'PUT'
      var additionalParams = {}
      var body = {
        rating: this.setRating,
        review: this.editedReviewText
      }
      try {
        this.$emit('loading')
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.editing = false
        this.$emit('reload')
      } catch (error) {
        this.$emit('loading')
        console.log(error)
      }
    },
    cancel () {
      this.editing = false
    }
  }
}
</script>

<style scoped>
.col-md-2 {
  min-width: 120px;
  padding-right: 0;
}

.round-image {
  width: 100px !important;
  height: 100px;
  border-radius: 50%;
  z-index: 1;
  object-fit: cover !important;
}

.needs-padding-bottom {
  padding-bottom: 2rem;
  position: relative;
}

.fa-star {
  color: orange;
}

p {
  margin: 0px;
}

hr {
  margin-top: 0;
}

.fa-window-close {
  position: absolute;
  right: 1rem;
  top: -.5rem;
  font-size: 25px;
  cursor: pointer;
  z-index: 3;
  color: #4f4f4f !important;
}

.edit-button {
  position: absolute;
  right: 1rem;
  bottom: .5rem;
  cursor: pointer;
  z-index: 3;
}

.save-button {
  position: absolute;
  right: 5rem;
  bottom: .5rem;
  cursor: pointer;
  z-index: 3;
}

.cancel-button {
  position: absolute;
  right: 1rem;
  bottom: .5rem;
  cursor: pointer;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/components/business/subnavItems/Review.vue